import * as React from "react";
import Box from "@mui/material/Box";
import classes from "./QuickTransferModal.module.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Controller, useForm } from "react-hook-form";

import { Grid, TextField, styled } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";

import TextFieldForm from "../../../../components/common/textFieldForm";

import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useLanguage } from "../../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "30vw",
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: "30px",
};

const ColorButton = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    // backgroundColor: "#F84B67",
    backgroundColor: "#323232",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "183px",
    height: "50px",
    "&:hover": {
        background: "#808080",
        color: "white",
    },
}));

const ColorButton1 = styled(Button)(({ theme }) => ({
    backgroundColor: "var(--button-color)",
    color: "#ffffff",
    border: "1px solid #CCC",
    borderRadius: "8px",
    width: "130px",
    height: "40px",
    "&:hover": {
        backgroundColor: "var(--button-hover-color)",
    },
    "&.Mui-disabled": {
        backgroundColor: "var(--light-color)",
        color: "var(--button-color)",
        cursor: "not-allowed",
    },
}));

const ColorButton2 = styled(Button)(({ theme }) => ({
    color: "#707070",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "#FFF",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "183px",
    height: "40px",
    "&:hover": {
        background: "var(--button-hover-color)",
        color: "white",
    },
}));

const defaultFormData = {
    accnumber: "",
    ifsccode: "",
    nickname: "",
    fullname: "",
    mobilenum: "",
    tpin: "",
};

export default function QuickTransferModal({
    open,
    handleClose,
    userId,
    handlerefresh,
}) {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        register,
        watch,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: defaultFormData,
        mode: "onChange",
    });

    const { loading, error, isAuthenticated, user } = useSelector(
        (state) => state.auth
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);

    const { t } = useLanguage();

    const primarycolor = getComputedStyle(document.documentElement)
        .getPropertyValue("--primary-color")
        .trim();

    const WithinSvg = `
 <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.0544 24.4395C27.0544 24.6349 26.9768 24.8224 26.8386 24.9606C26.7004 25.0988 26.5129 25.1764 26.3175 25.1764H5.68417C5.48873 25.1764 5.3013 25.0988 5.1631 24.9606C5.0249 24.8224 4.94727 24.6349 4.94727 24.4395C4.94727 24.2441 5.0249 24.0566 5.1631 23.9184C5.3013 23.7802 5.48873 23.7026 5.68417 23.7026H26.3175C26.5129 23.7026 26.7004 23.7802 26.8386 23.9184C26.9768 24.0566 27.0544 24.2441 27.0544 24.4395ZM5.7118 14.3236C5.66797 14.1691 5.67584 14.0045 5.73421 13.8548C5.79257 13.7052 5.89824 13.5787 6.03512 13.4946L15.6149 7.59939C15.731 7.52802 15.8646 7.49023 16.0008 7.49023C16.1371 7.49023 16.2707 7.52802 16.3868 7.59939L25.9666 13.4946C26.1035 13.5786 26.2092 13.705 26.2677 13.8546C26.3262 14.0042 26.3342 14.1688 26.2905 14.3233C26.2468 14.4779 26.1538 14.6139 26.0256 14.7108C25.8975 14.8076 25.7412 14.8599 25.5806 14.8597H23.3699V20.755H24.8437C25.0391 20.755 25.2266 20.8326 25.3648 20.9708C25.503 21.109 25.5806 21.2964 25.5806 21.4919C25.5806 21.6873 25.503 21.8748 25.3648 22.013C25.2266 22.1512 25.0391 22.2288 24.8437 22.2288H7.15798C6.96254 22.2288 6.77511 22.1512 6.63691 22.013C6.49871 21.8748 6.42107 21.6873 6.42107 21.4919C6.42107 21.2964 6.49871 21.109 6.63691 20.9708C6.77511 20.8326 6.96254 20.755 7.15798 20.755H8.63179V14.8597H6.42107C6.2606 14.8598 6.1045 14.8075 5.97648 14.7107C5.84847 14.6139 5.75553 14.478 5.7118 14.3236ZM17.4746 20.0181C17.4746 20.2135 17.5523 20.401 17.6905 20.5391C17.8287 20.6773 18.0161 20.755 18.2115 20.755C18.407 20.755 18.5944 20.6773 18.7326 20.5391C18.8708 20.401 18.9485 20.2135 18.9485 20.0181V15.5966C18.9485 15.4012 18.8708 15.2138 18.7326 15.0756C18.5944 14.9374 18.407 14.8597 18.2115 14.8597C18.0161 14.8597 17.8287 14.9374 17.6905 15.0756C17.5523 15.2138 17.4746 15.4012 17.4746 15.5966V20.0181ZM13.0532 20.0181C13.0532 20.2135 13.1309 20.401 13.2691 20.5391C13.4072 20.6773 13.5947 20.755 13.7901 20.755C13.9856 20.755 14.173 20.6773 14.3112 20.5391C14.4494 20.401 14.527 20.2135 14.527 20.0181V15.5966C14.527 15.4012 14.4494 15.2138 14.3112 15.0756C14.173 14.9374 13.9856 14.8597 13.7901 14.8597C13.5947 14.8597 13.4072 14.9374 13.2691 15.0756C13.1309 15.2138 13.0532 15.4012 13.0532 15.5966V20.0181Z" fill="${primarycolor}"/>
</svg>
`;
    const WithInSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(WithinSvg);


    const OtherBankSvg = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4643 16.6233C14.4643 16.7365 14.4193 16.8452 14.3392 16.9253C14.2591 17.0054 14.1504 17.0504 14.0371 17.0504H2.07611C1.96281 17.0504 1.85416 17.0054 1.77404 16.9253C1.69393 16.8452 1.64893 16.7365 1.64893 16.6233C1.64893 16.51 1.69393 16.4013 1.77404 16.3212C1.85416 16.2411 1.96281 16.1961 2.07611 16.1961H14.0371C14.1504 16.1961 14.2591 16.2411 14.3392 16.3212C14.4193 16.4013 14.4643 16.51 14.4643 16.6233ZM2.09212 10.7591C2.06672 10.6696 2.07128 10.5741 2.10511 10.4874C2.13895 10.4006 2.2002 10.3273 2.27955 10.2786L7.83289 6.86113C7.90018 6.81976 7.97763 6.79785 8.05662 6.79785C8.13562 6.79785 8.21306 6.81976 8.28036 6.86113L13.8337 10.2786C13.9131 10.3272 13.9744 10.4005 14.0083 10.4872C14.0422 10.5739 14.0468 10.6694 14.0215 10.759C13.9961 10.8486 13.9422 10.9274 13.8679 10.9836C13.7937 11.0397 13.7031 11.07 13.61 11.0699H12.3284V14.4874H13.1828C13.2961 14.4874 13.4047 14.5324 13.4848 14.6125C13.565 14.6926 13.61 14.8012 13.61 14.9145C13.61 15.0278 13.565 15.1365 13.4848 15.2166C13.4047 15.2967 13.2961 15.3417 13.1828 15.3417H2.93046C2.81717 15.3417 2.70851 15.2967 2.6284 15.2166C2.54829 15.1365 2.50329 15.0278 2.50329 14.9145C2.50329 14.8012 2.54829 14.6926 2.6284 14.6125C2.70851 14.5324 2.81717 14.4874 2.93046 14.4874H3.78482V11.0699H2.50329C2.41026 11.0699 2.31977 11.0396 2.24556 10.9835C2.17135 10.9274 2.11747 10.8486 2.09212 10.7591ZM8.91098 14.0602C8.91098 14.1735 8.95599 14.2821 9.0361 14.3622C9.11621 14.4423 9.22487 14.4874 9.33816 14.4874C9.45146 14.4874 9.56011 14.4423 9.64022 14.3622C9.72033 14.2821 9.76534 14.1735 9.76534 14.0602V11.4971C9.76534 11.3838 9.72033 11.2751 9.64022 11.195C9.56011 11.1149 9.45146 11.0699 9.33816 11.0699C9.22487 11.0699 9.11621 11.1149 9.0361 11.195C8.95599 11.2751 8.91098 11.3838 8.91098 11.4971V14.0602ZM6.3479 14.0602C6.3479 14.1735 6.39291 14.2821 6.47302 14.3622C6.55313 14.4423 6.66179 14.4874 6.77508 14.4874C6.88838 14.4874 6.99703 14.4423 7.07714 14.3622C7.15726 14.2821 7.20226 14.1735 7.20226 14.0602V11.4971C7.20226 11.3838 7.15726 11.2751 7.07714 11.195C6.99703 11.1149 6.88838 11.0699 6.77508 11.0699C6.66179 11.0699 6.55313 11.1149 6.47302 11.195C6.39291 11.2751 6.3479 11.3838 6.3479 11.4971V14.0602Z" fill="${primarycolor}"/>
<path d="M31.0503 25.6233C31.0503 25.7365 31.0052 25.8452 30.9251 25.9253C30.845 26.0054 30.7364 26.0504 30.6231 26.0504H18.662C18.5487 26.0504 18.4401 26.0054 18.36 25.9253C18.2799 25.8452 18.2349 25.7365 18.2349 25.6233C18.2349 25.51 18.2799 25.4013 18.36 25.3212C18.4401 25.2411 18.5487 25.1961 18.662 25.1961H30.6231C30.7364 25.1961 30.845 25.2411 30.9251 25.3212C31.0052 25.4013 31.0503 25.51 31.0503 25.6233ZM18.6781 19.7591C18.6527 19.6696 18.6572 19.5741 18.691 19.4874C18.7249 19.4006 18.7861 19.3273 18.8655 19.2786L24.4188 15.8611C24.4861 15.8198 24.5636 15.7979 24.6426 15.7979C24.7216 15.7979 24.799 15.8198 24.8663 15.8611L30.4196 19.2786C30.499 19.3272 30.5603 19.4005 30.5942 19.4872C30.6281 19.5739 30.6327 19.6694 30.6074 19.759C30.5821 19.8486 30.5282 19.9274 30.4539 19.9836C30.3796 20.0397 30.289 20.07 30.1959 20.0699H28.9144V23.4874H29.7687C29.882 23.4874 29.9907 23.5324 30.0708 23.6125C30.1509 23.6926 30.1959 23.8012 30.1959 23.9145C30.1959 24.0278 30.1509 24.1365 30.0708 24.2166C29.9907 24.2967 29.882 24.3417 29.7687 24.3417H19.5164C19.4031 24.3417 19.2945 24.2967 19.2143 24.2166C19.1342 24.1365 19.0892 24.0278 19.0892 23.9145C19.0892 23.8012 19.1342 23.6926 19.2143 23.6125C19.2945 23.5324 19.4031 23.4874 19.5164 23.4874H20.3708V20.0699H19.0892C18.9962 20.0699 18.9057 20.0396 18.8315 19.9835C18.7573 19.9274 18.7034 19.8486 18.6781 19.7591ZM25.4969 23.0602C25.4969 23.1735 25.5419 23.2821 25.622 23.3622C25.7021 23.4423 25.8108 23.4874 25.9241 23.4874C26.0374 23.4874 26.146 23.4423 26.2262 23.3622C26.3063 23.2821 26.3513 23.1735 26.3513 23.0602V20.4971C26.3513 20.3838 26.3063 20.2751 26.2262 20.195C26.146 20.1149 26.0374 20.0699 25.9241 20.0699C25.8108 20.0699 25.7021 20.1149 25.622 20.195C25.5419 20.2751 25.4969 20.3838 25.4969 20.4971V23.0602ZM22.9338 23.0602C22.9338 23.1735 22.9788 23.2821 23.059 23.3622C23.1391 23.4423 23.2477 23.4874 23.361 23.4874C23.4743 23.4874 23.583 23.4423 23.6631 23.3622C23.7432 23.2821 23.7882 23.1735 23.7882 23.0602V20.4971C23.7882 20.3838 23.7432 20.2751 23.6631 20.195C23.583 20.1149 23.4743 20.0699 23.361 20.0699C23.2477 20.0699 23.1391 20.1149 23.059 20.195C22.9788 20.2751 22.9338 20.3838 22.9338 20.4971V23.0602Z" fill="${primarycolor}"/>
<path d="M25.9349 13.7894L21.7363 12.0668C21.5978 12.0101 21.4792 11.9135 21.3956 11.7894C21.3119 11.6653 21.267 11.5191 21.2665 11.3694C21.266 11.2197 21.3099 11.0733 21.3926 10.9486C21.4754 10.8238 21.5933 10.7265 21.7315 10.6688L23.9912 9.7217C23.2083 7.95916 21.7778 6.56508 19.9956 5.828L19.9562 5.81185C18.13 5.05759 16.0803 5.05255 14.2504 5.79783C14.0656 5.86776 13.8607 5.86257 13.6797 5.7834C13.4986 5.70422 13.3557 5.55733 13.2816 5.37416C13.2075 5.19099 13.208 4.98608 13.283 4.80327C13.358 4.62045 13.5016 4.47426 13.683 4.39595C15.8788 3.50071 18.3389 3.5066 20.5304 4.41232L20.5768 4.43134C22.7287 5.32115 24.4532 7.00856 25.3895 9.1406L27.6526 8.19281C27.7907 8.13498 27.9428 8.11942 28.0897 8.1481C28.2366 8.17677 28.3717 8.24839 28.4779 8.35389C28.5841 8.45939 28.6566 8.59402 28.6862 8.74074C28.7158 8.88746 28.7013 9.03967 28.6443 9.17811L26.9218 13.3767C26.8456 13.5623 26.6989 13.71 26.5138 13.7874C26.3287 13.8648 26.1205 13.8655 25.9349 13.7894Z" fill="${primarycolor}"/>
<path d="M4.16422 18.2106L8.3628 19.9332C8.50133 19.9899 8.61991 20.0865 8.70355 20.2106C8.78718 20.3347 8.8321 20.4809 8.83262 20.6306C8.83314 20.7803 8.78924 20.9267 8.70647 21.0514C8.62371 21.1762 8.5058 21.2735 8.36767 21.3312L6.10791 22.2783C6.89078 24.0408 8.32134 25.4349 10.1035 26.172L10.1429 26.1881C11.9691 26.9424 14.0188 26.9474 15.8487 26.2022C16.0336 26.1322 16.2384 26.1374 16.4195 26.2166C16.6005 26.2958 16.7434 26.4427 16.8175 26.6258C16.8917 26.809 16.8912 27.0139 16.8161 27.1967C16.7411 27.3795 16.5976 27.5257 16.4161 27.604C14.2203 28.4993 11.7602 28.4934 9.56868 27.5877L9.52232 27.5687C7.37044 26.6788 5.64596 24.9914 4.7096 22.8594L2.44651 23.8072C2.30844 23.865 2.15633 23.8806 2.00942 23.8519C1.86251 23.8232 1.72741 23.7516 1.62122 23.6461C1.51504 23.5406 1.44254 23.406 1.41291 23.2593C1.38328 23.1125 1.39785 22.9603 1.45478 22.8219L3.17735 18.6233C3.2535 18.4377 3.40025 18.29 3.58532 18.2126C3.77039 18.1352 3.97863 18.1345 4.16422 18.2106Z" fill="${primarycolor}"/>
</svg>



`;
    const OtherBankSvgIcon =
        "data:image/svg+xml," + encodeURIComponent(OtherBankSvg);

    const [chosen, setChosen] = useState(null);

    const QUICK_LINKS = [
        {
            id: "otherbank",
            label: "Other Bank",
            icon: OtherBankSvgIcon,
            route: "/beneficiarymanagements/addexternal",
        },
        {
            id: "withinbank",
            label: "With In Bank",
            icon: WithInSvgIcon,
            route: "/beneficiarymanagements/addinternal",
        },
    ];

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title">
            <Box sx={style} className={classes.box1} component="form">
                <div className={classes.quicklinks}>
                    <div className={classes.modalql}>
                        <div className={classes.qlHeading}>
                            Quick Links
                        </div>
                        <div className={classes.cancelButton}>
                            <IconButton aria-label="delete" onClick={handleClose}>
                                <HighlightOffIcon />
                            </IconButton>
                        </div>

                    </div>

                    <div className={classes.mainQuickLinks}>
                        {QUICK_LINKS.map((link) => (
                            <button
                                key={link.id}
                                type="button"
                                onClick={() => setChosen(link.id)}
                                className={`${classes.quickLinksbox} ${chosen === link.id ? classes.selected : ""
                                    }`}
                            >
                                <div className={classes.accountBoxImage}>
                                    <img
                                        className={classes.iconImagesPaddingType1}
                                        src={link.icon}
                                        alt={link.label}
                                    />
                                </div>
                                <div className={classes.accDetailsHeading}>{link.label}</div>
                            </button>
                        ))}
                    </div>

                </div>

                <div className={classes.buttonDownloadStatement}>


                    <ColorButton1
                        disabled={!chosen}               // block until user picks something
                        onClick={() => {
                            const target = QUICK_LINKS.find((l) => l.id === chosen);
                            if (target) {
                                handleClose();               // close the modal
                                navigate(target.route);      // go to the page
                            }
                        }}
                    >
                        Proceed
                    </ColorButton1>
                </div>


            </Box>
        </Modal>

    );
}
